import React, { Component } from 'react'
import style from './style.styl'
import IconSVG from 'svg-inline-react'
import { ToolTip, Button } from '@driftt/tide-core-legacy'

const CARET_SRC = require('!svg-inline!images/right-arrow.svg')

export default class ConnectLink extends Component {
  static defaultProps = {
    label: 'Connect Account',
    buttonType: ''
  }

  renderButton = () => {
    const { handleConnect, label, buttonType, tooltipText, isDisabled } = this.props
    return (
      <ToolTip
        flow="right"
        hover={!!tooltipText}
        component={tooltipText}>
        <Button
          type={buttonType}
          onClick={handleConnect}
          disabled={isDisabled}
        >
          {label}
        </Button>
      </ToolTip>
    )
  }

  renderLink = () => {
    const { handleConnect, label } = this.props
    return (
      <div
        className={`flex ${style.IntegrationLink} ${style.IntegrationControl} connect-account`}
        onClick={handleConnect}>
        {label}
        <i className="connect-caret"><IconSVG src={CARET_SRC} /></i>
      </div>
    )
  }

  render() {
    const { connectorType, className } = this.props
    return (
      <div className={className}>
        {connectorType == 'button'
          ? this.renderButton()
          : this.renderLink()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/ConnectLink.js